import { UserRoles } from '@app/core/enums/userRoles.enum';
import { User } from '@app/core/interfaces';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import { State } from './auth.reducer';

export const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.authFeatureKey
);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (authState: fromAuth.State): boolean => authState.isAuthenticated
);

export const selectUser = createSelector(
  selectAuthState,
  (authState: State): User | null => authState.user
);

export const selectUserRole = createSelector(
  selectUser,
  (user: User | null): string => user?.role ? user?.role : ''
);

// Cognito does not guarantee group order, so check every role rather than `user.role`.
export const selectIsAdmin = createSelector(
  selectUser,
  (user: User | null): boolean =>
    user?.roles?.includes(UserRoles.admin) ?? user?.role === UserRoles.admin
);

export const selectIsSales = createSelector(
  selectUser,
  (user: User | null): boolean =>
    user?.roles?.includes(UserRoles.sales) ?? user?.role === UserRoles.sales
);
